const selectors$3 = {
  aos: '[data-aos]',
  collectionImage: '.collection-item__image',
  columnImage: '[data-column-image]',
  flickityNextArrow: '.flickity-button.next',
  flickityPrevArrow: '.flickity-button.previous',
  link: 'a:not(.btn)',
  productItemImage: '.product-item__image',
  section: '[data-section-id]',
  slide: '[data-slide]',
  slideValue: 'data-slide',
  sliderThumb: '[data-slider-thumb]',
};

const attributes$2 = {
  arrowPositionMiddle: 'data-arrow-position-middle',
  slideIndex: 'data-slide-index',
  sliderOptions: 'data-options',
  slideTextColor: 'data-slide-text-color',
};

const classes$3 = {
  aosAnimate: 'aos-animate',
  desktop: 'desktop',
  focused: 'is-focused',
  flickityEnabled: 'flickity-enabled',
  heroContentTransparent: 'hero__content--transparent',
  hidden: 'hidden',
  initialized: 'is-initialized',
  isLoading: 'is-loading',
  isSelected: 'is-selected',
  mobile: 'mobile',
  singleSlide: 'single-slide',
};

if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();

        this.flkty = null;
        this.bindEvents();
      }

      connectedCallback() {
        this.slides = this.querySelectorAll(selectors$3.slide);
        this.thumbs = this.querySelectorAll(selectors$3.sliderThumb);
        this.section = this.closest(selectors$3.section);
        this.initSlider();
      }

      initSlider() {
        if (this.slides.length <= 1) return;

        if (this.hasAttribute(attributes$2.sliderOptions)) {
          this.customOptions = JSON.parse(decodeURIComponent(this.getAttribute(attributes$2.sliderOptions)));
        }

        this.classList.add(classes$3.isLoading);

        let slideSelector = selectors$3.slide;
        const isDesktopView = !theme.isMobile;
        const slideDesktop = `${selectors$3.slide}:not(.${classes$3.mobile})`;
        const slideMobile = `${selectors$3.slide}:not(.${classes$3.desktop})`;
        const hasDeviceSpecificSelectors = this.querySelectorAll(slideDesktop).length || this.querySelectorAll(slideMobile).length;

        if (hasDeviceSpecificSelectors) {
          if (isDesktopView) {
            slideSelector = slideDesktop;
          } else {
            slideSelector = slideMobile;
          }

          this.flkty?.destroy();
        }

        if (this.querySelectorAll(slideSelector).length <= 1) {
          this.classList.add(classes$3.singleSlide);
          this.classList.remove(classes$3.isLoading);
          return;
        }

        this.sliderOptions = {
          cellSelector: slideSelector,
          contain: true,
          wrapAround: true,
          adaptiveHeight: true,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.classList.add(classes$3.initialized);
                this.classList.remove(classes$3.isLoading);
                this.parentNode.dispatchEvent(
                  new CustomEvent('theme:slider:loaded', {
                    bubbles: true,
                    detail: {
                      slider: this,
                    },
                  })
                );
              });

              this.slideActions();

              if (this.sliderOptions.prevNextButtons) {
                this.positionArrows();
              }
            },
            change: (index) => {
              const slide = this.slides[index];
              if (!slide || this.sliderOptions.groupCells) return;

              const elementsToAnimate = slide.querySelectorAll(selectors$3.aos);
              if (elementsToAnimate.length) {
                elementsToAnimate.forEach((el) => {
                  el.classList.remove(classes$3.aosAnimate);
                  requestAnimationFrame(() => {
                    // setTimeout with `0` delay fixes functionality on Mobile and Firefox
                    setTimeout(() => {
                      el.classList.add(classes$3.aosAnimate);
                    }, 0);
                  });
                });
              }
            },
            resize: () => {
              if (this.sliderOptions.prevNextButtons) {
                this.positionArrows();
              }
            },
          },
        };

        this.initFlickity();

        this.flkty.on('change', () => this.slideActions(true));

        this.thumbs?.forEach((thumb) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            const slideIndex = [...thumb.parentElement.children].indexOf(thumb);
            this.flkty.select(slideIndex);
          });
        });

        if (!this.flkty || !this.flkty.isActive) {
          this.classList.remove(classes$3.isLoading);
        }
      }

      initFlickity() {
        if (this.sliderOptions.fade) {
          this.flkty = new window.theme.FlickityFade(this, this.sliderOptions);
        } else {
          this.flkty = new window.theme.Flickity(this, this.sliderOptions);
        }
      }

      bindEvents() {
        this.addEventListener('theme:slider:init', () => {
          this.initSlider();
        });

        this.addEventListener('theme:slider:select', (e) => {
          this.flkty.selectCell(e.detail.index);
          this.flkty.stopPlayer();
        });

        this.addEventListener('theme:slider:deselect', () => {
          if (this.flkty && this.sliderOptions.hasOwnProperty('autoPlay') && this.sliderOptions.autoPlay) {
            this.flkty.playPlayer();
          }
        });

        this.addEventListener('theme:slider:reposition', () => {
          this.flkty?.reposition();
        });

        this.addEventListener('theme:slider:destroy', () => {
          this.flkty?.destroy();
        });

        this.addEventListener('theme:slider:remove-slide', (e) => {
          if (!e.detail.slide) return;

          this.flkty?.remove(e.detail.slide);

          if (this.flkty?.cells.length === 0) {
            this.section.classList.add(classes$3.hidden);
          }
        });
      }

      slideActions(changeEvent = false) {
        const currentSlide = this.querySelector(`.${classes$3.isSelected}`);
        if (!currentSlide) return;

        const currentSlideTextColor = currentSlide.hasAttribute(attributes$2.slideTextColor) ? currentSlide.getAttribute(attributes$2.slideTextColor) : '';
        const currentSlideLink = currentSlide.querySelector(selectors$3.link);
        const buttons = this.querySelectorAll(`${selectors$3.slide} a, ${selectors$3.slide} button`);

        if (document.body.classList.contains(classes$3.focused) && currentSlideLink && this.sliderOptions.groupCells && changeEvent) {
          currentSlideLink.focus();
        }

        if (buttons.length) {
          buttons.forEach((button) => {
            const slide = button.closest(selectors$3.slide);
            if (slide) {
              const tabIndex = slide.classList.contains(classes$3.isSelected) ? 0 : -1;
              button.setAttribute('tabindex', tabIndex);
            }
          });
        }

        this.style.setProperty('--text', currentSlideTextColor);

        if (this.thumbs.length && this.thumbs.length === this.slides.length && currentSlide.hasAttribute(attributes$2.slideIndex)) {
          const slideIndex = parseInt(currentSlide.getAttribute(attributes$2.slideIndex));
          const currentThumb = this.querySelector(`${selectors$3.sliderThumb}.${classes$3.isSelected}`);
          if (currentThumb) {
            currentThumb.classList.remove(classes$3.isSelected);
          }
          this.thumbs[slideIndex].classList.add(classes$3.isSelected);
        }
      }

      positionArrows() {
        if (!this.hasAttribute(attributes$2.arrowPositionMiddle) || !this.sliderOptions.prevNextButtons) return;

        const itemImage = this.querySelector(selectors$3.collectionImage) || this.querySelector(selectors$3.productItemImage) || this.querySelector(selectors$3.columnImage);

        // Prevent 'clientHeight' of null error if no image
        if (!itemImage) return;

        this.querySelector(selectors$3.flickityPrevArrow).style.top = itemImage.clientHeight / 2 + 'px';
        this.querySelector(selectors$3.flickityNextArrow).style.top = itemImage.clientHeight / 2 + 'px';
      }

      disconnectedCallback() {
        if (this.flkty) {
          this.flkty.options.watchCSS = false;
          this.flkty.destroy();
        }
      }
    }
  );
}
